import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";

interface DemoBadgeProps {
  label?: string;
  variant?: "green" | "purple" | "blue";
  size?: "sm" | "md";
  className?: string;
}

const variantStyles = {
  green: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30 dark:text-emerald-400",
  purple: "bg-violet-500/15 text-violet-700 border-violet-500/30 dark:text-violet-400",
  blue: "bg-sky-500/15 text-sky-700 border-sky-500/30 dark:text-sky-400",
};

export const DemoBadge = ({ label = "DEMO", variant = "green", size = "sm", className }: DemoBadgeProps) => (
  <span className={cn(
    "inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wider",
    variantStyles[variant],
    size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs",
    className
  )}>
    <Sparkles className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
    {label}
  </span>
);
